import 'slick-carousel'
export default class SlickSlider{

    constructor(){

        this.homeSlider()
        this.testimonialsSlider()

    }

    homeSlider(){
        $('.home__slides').slick({
            autoplay: true,
            autoplaySpeed: 5000,
            pauseOnHover: false,
            pauseOnFocus: false,
            arrows: false,
            dots: true
        })
    }

    testimonialsSlider(){
        
        $('.reviews__slider').slick({
            mobileFirst: true,
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 1199,
                    settings: {
                        slidesToShow: 3,
                    }
                }
            ]
        })

    }

}